import React from "react";
import { Container } from "manifest-components/src/Containers";
import { AccountCreationScreen } from "./AccountCreationScreen";
import type { CreateAccountPageControllerType } from "./CreateAccountPageController";

const CreateAccountScreen = (props: CreateAccountPageControllerType) => {
  return (
    <Container>
      <AccountCreationScreen {...props} />
    </Container>
  );
};

export { CreateAccountScreen };
